import { render } from "./MessageItem.vue?vue&type=template&id=681364ba&scoped=true&ts=true"
import script from "./MessageItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageItem.vue?vue&type=script&setup=true&lang=ts"

import "./MessageItem.vue?vue&type=style&index=0&id=681364ba&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681364ba"],['__file',"src/components/MessageItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "681364ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('681364ba', __exports__)) {
    console.log('reload')
    api.reload('681364ba', __exports__)
  }
  
  module.hot.accept("./MessageItem.vue?vue&type=template&id=681364ba&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('681364ba', render)
  })

}


export default __exports__